import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const BillingCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to billing page after a short delay
    const timer = setTimeout(() => {
      navigate('/billing');
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
      }}
    >
      <CancelIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
      <Typography variant="h4" gutterBottom>
        Payment Cancelled
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Redirecting back to billing...
      </Typography>
      <CircularProgress size={24} />
    </Box>
  );
};

export default BillingCancel; 